module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="icon-header subscription">'+
((__t=( i18n.tc("SubscriptionPanel", "Subscription details") ))==null?'':__t)+
'</h4><div class="content"><dl><dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Device name:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientAlias ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Device type:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( unitType ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Subscription type:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientName ))==null?'':__t)+
'</dd> ';
 if ( active ) { 
__p+=' <dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Created date:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( validFromDate ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Renewal date:") ))==null?'':__t)+
'</dt><dd class="'+
((__t=( ( renewable ) ? "success" : "warning" ))==null?'':__t)+
'">'+
((__t=( renewalDate ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=( i18n.tc("SubscriptionPanel", "Registered to:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( customerName ))==null?'':__t)+
'</dd></dl></div> ';
 if ( ! active ) { 
__p+=' <p class="error"><em>'+
((__t=( i18n.tc("SubscriptionPanel", "This subscription is inactive.") ))==null?'':__t)+
'</em></p> ';
 } else if ( ! renewable ) { 
__p+=' <p class="warning"><em>'+
((__t=( i18n.tc("SubscriptionPanel", "This subscription will end on %s.").format( renewalDate) ))==null?'':__t)+
'</em></p> ';
 } 
__p+=' <fieldset><legend>'+
((__t=( i18n.tc("SubscriptionPanel", "Subscription options") ))==null?'':__t)+
'</legend><button data-click="settings-transfer">'+
((__t=( i18n.tc("SubscriptionPanel", "Transfer") ))==null?'':__t)+
'</button> <button data-click="settings-terminate">'+
((__t=( i18n.tc("SubscriptionPanel", "Terminate") ))==null?'':__t)+
'</button> ';
 if ( ! renewable && transientCanRenew ) { 
__p+=' <button data-click="settings-renew">'+
((__t=( i18n.tc("SubscriptionPanel", "Renew") ))==null?'':__t)+
'</button> ';
 } 
__p+=' <button data-click="settings-replace">'+
((__t=( i18n.tc("SubscriptionPanel", "Replace") ))==null?'':__t)+
'</button></fieldset><fieldset class="button-wrap"><button class="primary" data-click="settings-close">'+
((__t=( i18n.tc("SubscriptionPanel", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
